import * as go from 'gojs';
import noop from 'lodash/noop';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { imageNodeTemplate } from '../image-node';

export const setupImageNode = (diagram: go.Diagram, categoryName: string) => {
  registerNodeTemplate(diagram, categoryName, imageNodeTemplate());
  return noop;
};
